var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOurMission(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.233,
    height: 64.23,
    viewBox: "0 0 64.233 64.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#f0b33f}.cls-3{fill:#002173}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rocket",
    transform: "translate(-31.71 -31.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15496",
    d: "M58.564 217.764l-.813.813a.859.859 0 0 0 0 1.215l8.516 8.514 1.215-1.215-7.908-7.907.206-.206a9.787 9.787 0 0 1 13.809-.005l1.225-1.2-.017-.017a11.506 11.506 0 0 0-16.233.008z",
    className: "cls-1",
    "data-name": "Path 15496",
    transform: "translate(-22.097 -156.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15497",
    d: "M211.065 333.593l-1.205 1.225v-.005l.009.011a9.781 9.781 0 0 1-.009 13.8l-.206.206-7.907-7.906-1.215 1.215 8.514 8.514a.859.859 0 0 0 1.215 0l.813-.813a11.5 11.5 0 0 0 .034-16.207c-.022-.019-.036-.033-.043-.04z",
    className: "cls-1",
    "data-name": "Path 15497",
    transform: "translate(-144.644 -258.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15498",
    fill: "#1ae5be",
    d: "M265.115 341.441a.865.865 0 0 1-.093-.112.784.784 0 0 0 .093.112z",
    "data-name": "Path 15498",
    transform: "translate(-199.904 -265.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15499",
    d: "M51.337 349.225a9.544 9.544 0 0 0-9.331-7.525h-.235a10.167 10.167 0 0 0-9.954 9.963l-.107 9.008a.859.859 0 0 0 .859.869h.01l9.019-.106a10.167 10.167 0 0 0 9.954-9.956v-.463a9.631 9.631 0 0 0-.215-1.79zm-1.739.107a4.344 4.344 0 1 1-5.676-5.676 7.841 7.841 0 0 1 5.676 5.676zm-8.03 10.387l-8.13.1.1-8.12a8.447 8.447 0 0 1 7.694-8.239 6.06 6.06 0 1 0 8.571 8.571 8.447 8.447 0 0 1-8.235 7.688z",
    className: "cls-1",
    "data-name": "Path 15499",
    transform: "translate(0 -265.593)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11396",
    "data-name": "Group 11396",
    transform: "translate(42.039 31.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15500",
    d: "M156.882 31.721l-11.783.159a18.619 18.619 0 0 0-14.486 7.184l-26.581 34a.859.859 0 0 0 .068 1.136l11.169 11.17a.859.859 0 0 0 1.137.069l2.416-1.889 31.121-24.331.465-.362a18.617 18.617 0 0 0 7.184-14.485l.16-11.783a.859.859 0 0 0-.871-.871zm-40.934 51.9l-10.094-10.097 2.835-3.626 10.886 10.886zm39.926-39.268a16.9 16.9 0 0 1-6.236 12.922 55.375 55.375 0 0 0-10.878-12.61.859.859 0 1 0-1.117 1.305 53.666 53.666 0 0 1 10.637 12.372l-27.342 21.375-11.183-11.183L131.127 41.2c1.281.8 2.539 1.655 3.745 2.557a.859.859 0 1 0 1.029-1.376c-1.194-.892-2.437-1.742-3.705-2.539a16.9 16.9 0 0 1 12.926-6.242l10.9-.147z",
    className: "cls-3",
    "data-name": "Path 15500",
    transform: "translate(-103.849 -31.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15501",
    d: "M295.726 159.552a4.239 4.239 0 1 0 5.994 0 4.239 4.239 0 0 0-5.994 0zm4.78 4.779a2.521 2.521 0 1 1 0-3.564 2.521 2.521 0 0 1 0 3.564z",
    className: "cls-3",
    "data-name": "Path 15501",
    transform: "translate(-267.187 -140.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15502",
    d: "M245.975 211.085a4.239 4.239 0 1 0 3.917 2.617 4.237 4.237 0 0 0-3.917-2.617zm1.783 6.021a2.521 2.521 0 1 1 0-3.564 2.521 2.521 0 0 1-.001 3.564z",
    className: "cls-3",
    "data-name": "Path 15502",
    transform: "translate(-221.996 -185.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15503",
    d: "M190.172 265.112a4.238 4.238 0 1 0 5.994 0 4.238 4.238 0 0 0-5.994 0zm4.78 4.779a2.52 2.52 0 1 1 .739-1.782 2.52 2.52 0 0 1-.739 1.782z",
    className: "cls-3",
    "data-name": "Path 15503",
    transform: "translate(-176.747 -230.628)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15504",
    d: "M334.719 56.331a14.333 14.333 0 0 0-7.759 2.638.859.859 0 1 0 1 1.4 12.619 12.619 0 0 1 6.832-2.322.859.859 0 0 0-.069-1.717z",
    className: "cls-3",
    "data-name": "Path 15504",
    transform: "translate(-294.703 -52.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15505",
    d: "M396.1 57.682h.011l1.111-.014a.859.859 0 1 0-.022-1.718l-1.111.014a.859.859 0 0 0 .011 1.718z",
    className: "cls-3",
    "data-name": "Path 15505",
    transform: "translate(-353.516 -52.48)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurMission);
export default __webpack_public_path__ + "static/media/our-mission.3ebe6f50870962742e601156ead9ffbf.svg";
export { ForwardRef as ReactComponent };